import { render } from "./BrowseSection.vue?vue&type=template&id=43bd18b8&scoped=true"
import script from "./BrowseSection.vue?vue&type=script&lang=js"
export * from "./BrowseSection.vue?vue&type=script&lang=js"

import "./BrowseSection.vue?vue&type=style&index=0&id=43bd18b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bd18b8"]])

export default __exports__